import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import helpCategoryService from "../services/help-category-service";

export const helpCategorySearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const helpCategoriesQueryOptions = (
	search?: z.infer<typeof helpCategorySearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["help_category", search],
		queryFn: () =>
			helpCategoryService.list(transformSearch(search, ["search"])),
		...options,
	});
};

export const helpCategoryQueryOptions = (id: string) => {
	return queryOptions({
		queryKey: ["help_category", id],
		queryFn: () => helpCategoryService.findById(id),
	});
};

export const useHelpCategoryCreateMutation = (id?: string) => {
	return useMutation({
		mutationKey: ["help_category", id],
		mutationFn: helpCategoryService.create,
		meta: {
			successMessage: "Help Category created successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["help_category"] }),
	});
};

export const useHelpCategoryMutation = (id?: string) => {
	return useMutation({
		mutationKey: ["help_category", id],
		mutationFn: helpCategoryService.upsert,
		meta: {
			successMessage: "Help Category updated successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["help_category"] }),
	});
};
